var React = require('react');

function GmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44,49H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H44a5.006,5.006,0,0,1,5,5V44A5.005,5.005,0,0,1,44,49ZM11.216,12.413a3.381,3.381,0,0,0-3.376,3.37V34.839a2.241,2.241,0,0,0,2.241,2.243h5.233v-12.7L24.28,31.1l8.967-6.727v12.7h5.233a2.244,2.244,0,0,0,2.241-2.241V15.783a3.381,3.381,0,0,0-3.377-3.37,3.32,3.32,0,0,0-2,.679l-2.093,1.569L24.28,21.388l-8.967-6.724L13.22,13.092A3.32,3.32,0,0,0,11.216,12.413Z","fill":"#fff"}));
}

GmailInline.defaultProps = {"width":"49","height":"49","viewBox":"0 0 49 49"};

module.exports = GmailInline;

GmailInline.default = GmailInline;
